module.exports = __webpack_public_path__ + "static/img/homeBg.fe70dde8.jpg";